export enum LabelsFields {
  type = "type",
  detachable = "detachable",
  shape = "shape",
  width = "width",
  length = "length",
  diameter = "diameter",
  mainColor = "mainColor",
  otherMainColor = "otherMainColor",
  printColors = "printColors",
  designFile = "designFile",
  amountPcs = "amountPcs",
}
